import { Button, Modal, Input, Form, Tooltip } from "@renderbus/ui";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { IDingTalkOrganization } from "../child-integration-setting/hooks/useChildIntergrationSettingInfo";
import { useChildManageSider } from "./hooks/useChildManageSider";
import { ChildManageTree } from "../child-manage-tree";
import { useValidatorChinese } from "../../hooks/useValidator";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";
import { createGlobalStyle } from "styled-components";
import {
  IdeptInfo,
  useDingTalkSubAccountStore,
} from "../../store/dingtalk-subaccount-store";

export function ChildManageSider({
  dataSource = [],
}: {
  dataSource?: IdeptInfo[] | IDingTalkOrganization[];
}) {
  const { t } = useTranslation("childManager");
  const { enterpriseAliasValidator } = useValidatorChinese();
  const {
    openSubNameModal,
    openDeleteDeptModal,
    setOpenDeleteDeptModal,
    setOpenSubNameModal,
    handleEditEnterpriseName,
    currentBtnStatus,
    enterpriseAliasForm,
    handleWatchInputValue,
    handleDeleteDept,
    handleFilterDept,
  } = useChildManageSider();
  const { checkTreeInfo, currentEnterpriseAlias } =
    useDingTalkSubAccountStore();

  return (
    <ChildManageTreeContainer>
      <ChildManageTreeHeader>
        <ChildManageTreeHeaderSubTitle>
          <span>{t("dingtalk_subaccount_setting_enterprise_name")}</span>
          <Button
            type="text"
            onClick={() => {
              setOpenSubNameModal(true);
              enterpriseAliasForm.setFieldsValue({
                enterpriseAlias: currentEnterpriseAlias || "",
              });
            }}
          >
            {t("dingtalk_subaccount_initial_edit")}
          </Button>
        </ChildManageTreeHeaderSubTitle>
        <ChildManageTreeHeaderTitle>
          <Tooltip
            placement="top"
            title={currentEnterpriseAlias}
            color={"#202124"}
            tooltipText={
              <div className="enterprisealias-tooltip">
                {currentEnterpriseAlias}
              </div>
            }
          />
        </ChildManageTreeHeaderTitle>
      </ChildManageTreeHeader>
      <TreeWrapper showOperateBtn={!!checkTreeInfo.length}>
        <Input
          placeholder={t("dingtalk_subaccount_department_placeholder")}
          suffix={<SearchOutlined />}
          className="dingtalk_222227"
          onChange={(e) => handleFilterDept(e.target.value)}
        />
        <ChildManageTree dataSource={dataSource} />
      </TreeWrapper>
      {!!checkTreeInfo.length && (
        <ChildManageFooter>
          <OperateBtn
            icon={<DeleteOutlined />}
            onClick={() => setOpenDeleteDeptModal(true)}
          />
        </ChildManageFooter>
      )}
      <Modal
        open={openDeleteDeptModal}
        title={t("dingtalk_subaccount_delete_title")}
        className="renderbus-ui--modal dingtalk-delete-modal"
        children={
          <ChildManageDeleteContainer>
            <div className="warn-text">
              {t("dingtalk_subaccount_delete_dept_tip")}
            </div>
            <div className="title">
              {t("dingtalk_subaccount_delete_tip", {
                dept: checkTreeInfo.map((item: any) => item.name).join(","),
              })}
            </div>
          </ChildManageDeleteContainer>
        }
        okText={t("dingtalk_subaccount_dept_delete_okText")}
        onCancel={() => setOpenDeleteDeptModal(false)}
        onOk={() =>
          handleDeleteDept({
            deptIdList: checkTreeInfo.map((item) => item.deptId),
          })
        }
      />
      <Modal
        open={openSubNameModal}
        width={620}
        title={`${t("dingtalk_subaccount_initial_edit")}${t(
          "dingtalk_subaccount_setting_enterprise_name"
        )}`}
        children={
          <ChildManageEditNameWrapper>
            <Form
              size={"large"}
              form={enterpriseAliasForm}
              layout="vertical"
              className="verification-form"
            >
              <Form.Item
                name="enterpriseAlias"
                validateTrigger="onBlur"
                label={
                  <div>
                    {t("dingtalk_subaccount_setting_enterprise_name")}
                    <br />
                    <div className="help-text">
                      {t("dingtalk_subaccount_name_change_help")}
                    </div>{" "}
                  </div>
                }
                rules={[
                  {
                    validator: () =>
                      enterpriseAliasValidator(
                        enterpriseAliasForm.getFieldValue("enterpriseAlias")
                      ),
                  },
                ]}
              >
                <Input
                  className="background-2C2C31"
                  onBlur={handleWatchInputValue}
                />
              </Form.Item>
            </Form>
            <VerificationRulesContainer>
              <span>{t("dingtalk_subaccount_setting_name_rules1")}</span>
              <span>{t("dingtalk_subaccount_setting_name_rules2")}</span>
              <span>{t("dingtalk_subaccount_setting_name_rules3")}</span>
            </VerificationRulesContainer>
            <Button
              type="primary"
              disabled={!currentBtnStatus}
              onClick={handleEditEnterpriseName}
            >
              {t("dingtalk_subaccount_name_change_btn")}
            </Button>
          </ChildManageEditNameWrapper>
        }
        onCancel={() => {
          setOpenSubNameModal(false);
          enterpriseAliasForm.resetFields();
        }}
        footer={null}
      />
      <DingTalkDeleteStyle />
    </ChildManageTreeContainer>
  );
}
const DingTalkDeleteStyle = createGlobalStyle`
  .dingtalk-delete-modal .ant-modal-header {
    text-align: center;
  }
  .dingtalk-delete-modal .ant-modal-title {
    font-size: 18px !important;
  }
  .dingtalk-delete-modal .ant-modal-body {
    padding: 0 0 24px !important;
  }
  .dingtalk-delete-modal .ant-modal-footer .ant-btn:nth-child(2){
    background: #DF4036 !important;
    border-color: #DF4036;
  }
`;

const ChildManageDeleteContainer = styled.div`
  .title {
    margin-bottom: 8px;
    text-align: center;
    padding: 46px 0 36px;
  }
  .warn-text {
    font-size: 14px;
    color: rgba(224, 63, 52, 1);
    background: #453638;
    padding: 10px 20px;
  }
`;
const ChildManageEditNameWrapper = styled.div`
  margin: 20px auto 0;
  color: rgba(212, 212, 212, 1);
  width: 444px;
  .help-text {
    color: rgba(151, 160, 161, 1);
    margin-bottom: 34px;
    margin-top: 2px;
    font-size: 12px;
  }
  .title {
    margin-bottom: 6px;
    line-height: 22px;
  }
  .ant-btn {
    margin-left: 162px;
    &:disabled,
    &:disabled:hover {
      color: #ffffff !important;
      background: #75c9a2 !important;
    }
  }
`;

const ChildManageTreeContainer = styled.div`
  border-right: 1px solid rgba(62, 64, 68, 1);
  padding-top: 18px;
  color: rgba(255, 255, 255, 0.85);
  width: 240px;
`;

const ChildManageTreeHeader = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 10px 12px;
`;
const ChildManageTreeHeaderTitle = styled.div`
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 12px;
  width: 240px;
  .enterprisealias-tooltip {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 220px;
  }
`;

const ChildManageTreeHeaderSubTitle = styled.div`
  color: #a7b1b4;
  padding-bottom: 4px;
  font-size: 12px;
  .ant-btn {
    color: var(--main-color);
    font-size: 12px !important;
    padding: 0 8px;
    height: 16px;
    line-height: 1;
    &:hover {
      color: var(--main-color) !important;
    }
  }
`;
const TreeWrapper = styled.div<{ showOperateBtn: boolean }>`
  padding: 6px 0;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: ${(p) =>
    p.showOperateBtn ? "calc(100vh - 300px)" : "calc(100vh - 260px)"};
  ::-webkit-scrollbar {
    width: 0;
  }
`;
const VerificationRulesContainer = styled.div`
  color: rgba(151, 160, 161, 1);
  line-height: 20px;
  margin-top: 24px;
  margin-bottom: 72px;
  font-size: 12px;
  span {
    position: relative;
    padding-right: 26px;
    &::after {
      position: absolute;
      content: "";
      width: 1px;
      top: 4px;
      height: 10px;
      right: 13px;
      background: rgba(74, 82, 86, 1);
    }
  }
  span:last-child {
    padding-right: 0;
    &:after {
      display: none;
    }
  }
`;
const ChildManageFooter = styled.div`
  border-top: 1px solid #3e4044;
  height: 46px;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  width: 240px;
  padding: 10px 10px 10px 20px;
`;
const OperateBtn = styled(Button)`
  background: #1b1d1e !important;
  color: var(--main-color);
  font-size: 12px !important;
  padding: 2px 10px;
  height: 28px;
  svg {
    color: #df4036;
  }
  &:hover {
    color: var(--main-color) !important;
  }
`;
